import { DeliveryModel, ProductionOwnership, Severity } from './types';

export const NOT_DEFINED = 'Not defined';

export const PPC_LINK_NOT_CONFIRMED_MESSAGE = 'PPC link has not been confirmed for more than 1 month.';

export const OWNERSHIP_OPTIONS = [
  { value: ProductionOwnership.OUR_TEAM, label: 'Our team' },
  { value: ProductionOwnership.CLIENT_SIDE, label: 'Client side' },
];

export const DELIVERY_MODEL_OPTIONS = [
  { value: DeliveryModel.LEAN, label: 'Lean' },
  { value: DeliveryModel.STANDARD, label: 'Standard' },
  { value: DeliveryModel.REGULATED, label: 'Regulated' },
];

export const SEVERITY_OPTIONS = [
  { value: Severity.LOW, label: 'Low' },
  { value: Severity.MEDIUM, label: 'Medium' },
  { value: Severity.HIGH, label: 'High' },
  { value: Severity.CRITICAL, label: 'Critical' },
];

export const BOOLEAN_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

export const getOptionLabel = (options: { value: string; label: string }[], value: string) =>
  options.find(o => o.value === value)?.label;
